<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
} = UIKit

const props = withDefaults(
    defineProps<{
        title?: string
        bannerId?: string
        linkUrl?: string
        isRedBanner?: boolean
        linkText?: string
    }>(),
    {
        title: '',
        bannerId: undefined,
        linkUrl: undefined,
        isRedBanner: false,
        linkText: 'View instructions',
    }
)

const visitLink = () => {
    if (props.linkUrl) {
        window.open(props.linkUrl)
    }
}
</script>

<template>
    <div
        class="banner"
        :class="{
            'banner--red': props.isRedBanner
        }"
    >
        <div v-if="props.title" class="banner__title">
            {{ props.title }}
        </div>
        <div class="banner__text">
            <slot />
        </div>
        <slot name="link">
            <PocketButton
                class="banner__confirmation"
                type="tertiary"
                @click="visitLink"
            >
                {{ props.linkText }}
            </PocketButton>
        </slot>
    </div>
</template>

<style lang="scss" scoped>


.banner {
    position: relative;
    padding: 14px 12px 12px 13px;
    background-color: rgba($sky-blue, 0.3);
    border-radius: 5px;
    border: 1px solid rgba($brand-blue, 0.4);

    &--red {
        // Calling it red instead of error
        background-color: $barely-red;
        border-radius: 5px;
        border: 1px solid rgba($red-pegasus, 0.5);
    }

    &__close {
        position: absolute;
        top: 14px;
        right: 12px;
        color: $pewter;
        cursor: pointer;

        &:hover {
            color: $brand-black;
        }
    }

    &__title {
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 9px;
        line-height: 20px;
    }

    &__text {
        font-size: 14px;
        line-height: 19.12px;
        margin-bottom: 14px;
    }
}
</style>
